import { render, staticRenderFns } from "./ModalPedidoOrdenComponent.vue?vue&type=template&id=4b64ce62&"
import script from "./ModalPedidoOrdenComponent.vue?vue&type=script&lang=js&"
export * from "./ModalPedidoOrdenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports